import $ from 'jquery';
import 'slick-carousel';

function initMediaAndTextSlider() {
	let slides = $('.ucg-media-and-text-slider-block .slides');
	let firstSlide = $('.ucg-media-and-text-slider-block .slides .slide-1');

	slides.on('init', function () {
		firstSlide
			.find('.words')
			.css({ opacity: '0', top: 100 })
			.delay(1000)
			.animate(
				{
					easing: 'ease-in',
					opacity: 1,
					top: -100,
				},
				1000
			)
			.delay(2000)
			.animate(
				{
					easing: 'ease-out',
					opacity: 0,
				},
				1500
			);
	});

	slides.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		$(
			'.ucg-media-and-text-slider-block .slides .slick-slide[data-slick-index="' +
				nextSlide +
				'"]'
		)
			.find('.words')
			.css({ opacity: '0', top: 100 })
			.delay(1000)
			.animate(
				{
					easing: 'ease-in',
					opacity: 1,
					top: -100,
				},
				1000
			);
	});

	slides.on('afterChange', function (event, slick, currentSlide, nextSlide) {
		if (currentSlide == slick.slideCount - 1) {
			setTimeout(() => {
				$('html, body').animate(
					{
						scrollTop: $('#contactFormGroup').position().top - 75,
					},
					'slow'
				);
			}, 5000);
			slides.slickSetOption('autoplay', false, false);
		}

		$('.ucg-media-and-text-slider-block .slides .slick-active')
			.find('.words')
			.delay(2000)
			.animate(
				{
					easing: 'ease-out',
					opacity: 0,
				},
				1500
			);
	});

	if (slides.length && slides.find('.slide-2').length) {
		slides.not('.slick-initialized').slick({
			arrows: false,
			autoplay: true,
			autoplaySpeed: 5000,
			dots: false,
			infinite: false,
			pauseOnHover: false,
			pauseonFocus: false,
			speed: 1000,
			vertical: true,
		});
	}
}

$(window).on('load resize', function () {
	initMediaAndTextSlider();
});
